import React, { useState, useMemo, useEffect } from 'react';
import { AdminLayout } from 'src/Layouts';
import TicketsTable from 'src/Components/TicketsTable';
import FilterDropdown from 'src/Components/FilterDropdown';
import SearchInput from 'src/Components/SearchInput';
import CreateTicketButton from 'src/Components/Tickets/CreateTicketButton';
import { Container, Title, TableContainer, HeaderContainer, ControlsContainer, } from 'src/Views/TicketsPage/styles';
import { useTicketFilters } from 'src/Views/TicketsPage/hooks/useTicketFilters';
import { useTicketsWithFilters } from 'src/Views/TicketsPage/hooks/useTicketsWithFilters';
import { useDebounce } from 'src/Utils/hooks/useDebounce';
var ClientTicketsPage = function () {
    var _a = useState(''), ticketSearch = _a[0], setTicketSearch = _a[1];
    var _b = useState(null), buildingId = _b[0], setBuildingId = _b[1];
    var buildings = useTicketFilters({ fetchAdmins: false }).buildings;
    var _c = useTicketsWithFilters(), tickets = _c.tickets, loading = _c.loading, error = _c.error, totalPages = _c.totalPages, currentPage = _c.currentPage, setPage = _c.setPage, setFilters = _c.setFilters;
    var debouncedSearch = useDebounce(ticketSearch, 500);
    var apiFilters = useMemo(function () {
        var filters = {};
        if (debouncedSearch) {
            filters.ticket_number = debouncedSearch;
        }
        if (buildingId) {
            filters.building_id = buildingId;
        }
        return filters;
    }, [debouncedSearch, buildingId]);
    useEffect(function () {
        setFilters(apiFilters);
    }, [apiFilters, setFilters]);
    return (React.createElement(AdminLayout, null,
        React.createElement(Container, null,
            React.createElement(Title, null, "Lista de Reclamos"),
            React.createElement(TableContainer, null,
                React.createElement(HeaderContainer, null,
                    React.createElement(ControlsContainer, null,
                        React.createElement(SearchInput, { label: "# Reclamo", placeholder: "Buscar # de reclamo", value: ticketSearch, onChange: setTicketSearch }),
                        React.createElement("div", { style: { width: 210 } },
                            React.createElement(FilterDropdown, { label: "Edificio", placeholder: "Selecciona edificio", options: buildings.map(function (building) { return ({
                                    value: building.id,
                                    label: building.name,
                                }); }), value: buildingId, onChange: setBuildingId, clearable: true }))),
                    React.createElement(CreateTicketButton, { fixedType: "external", buildingId: buildingId })),
                React.createElement(TicketsTable, { tickets: tickets, loading: loading, error: error, totalPages: totalPages, currentPage: currentPage, onPageChange: setPage, isClientView: true })))));
};
export default ClientTicketsPage;
